import { FC, useState } from 'react';
import { CatButton } from '@blocks-react/components/Button';
import { useTranslations } from 'next-intl';
import { Conditional } from 'components/pcc-components';
import { ProductDealerPriceAvailability } from 'services/dealerPriceAvailability/types';
import { revalidateCart } from 'services/parts-diagram/actions';
import Styles from './../parts-overview.module.scss';
import { usePartDiagram } from 'hooks/use-part-diagram/parts-diagram-context';
import { LineItem } from 'types/parts-diagram';
import QuantityInput from 'components/quantity-Input';
import PartsAvailabilityWrapper from 'components/parts-availability-wrapper';

export interface PriceAndAvailabilityProps {
  lineItem: LineItem;
  handleQuantityChange: (value: string) => void;
  modifiedPriceData: ProductDealerPriceAvailability;
  disableRow: boolean;
  isLoading: boolean;
}

export const PriceAndAvailability: FC<PriceAndAvailabilityProps> = ({
  lineItem,
  handleQuantityChange,
  modifiedPriceData,
  disableRow,
  isLoading
}) => {
  const t = useTranslations();
  const {
    isCatCorp,
    handleAddToCart,
    disableAddToCart,
    analyticsCommonInfo: { dealerData, model, currency } = {}
  } = usePartDiagram();
  const {
    quantity,
    disambiguation,
    ieSystemControlNumber,
    priceAndAvailabilityData,
    partNumber
  } = lineItem;

  const [modifiedQuantity, setModifiedQuantity] = useState(
    quantity.trim().length === 0 ? '1' : quantity
  );

  const analyticsInformation = {
    currency,
    model,
    dealerData
  };

  const isReplacedPart =
    priceAndAvailabilityData?.indirectReplacement ||
    (Array.isArray(priceAndAvailabilityData?.replacementParts) &&
      priceAndAvailabilityData?.replacementParts.length > 0);

  return (
    <>
      <p className="cat-u-theme-typography-label-sm m-0">
        {`${t('QUANTITY1')}:`}
      </p>

      <div className={Styles['parts-overview-stepper']}>
        <QuantityInput
          inputValue={modifiedQuantity}
          disabled={disableRow}
          handleQuantityChange={(value: string) => {
            setModifiedQuantity(value);
            handleQuantityChange(value);
          }}
        />
      </div>

      {!disambiguation && (
        <Conditional
          test={!!ieSystemControlNumber}
          fallback={
            !isCatCorp &&
            !isReplacedPart &&
            priceAndAvailabilityData?.enableAddToCart && (
              <CatButton
                size="sm"
                variant="primary"
                disabled={
                  disableAddToCart ||
                  disableRow ||
                  modifiedQuantity === '0' ||
                  modifiedQuantity === undefined
                }
                onClick={() => {
                  handleAddToCart(
                    lineItem,
                    modifiedQuantity,
                    analyticsInformation
                  );
                  revalidateCart();
                }}
              >
                {t('ADD_TO_CART')}
              </CatButton>
            )
          }
        />
      )}
      <div>
        <PartsAvailabilityWrapper
          availabilityData={
            partNumber === modifiedPriceData?.partNumber
              ? modifiedPriceData
              : priceAndAvailabilityData
          }
          shouldDisplayLabel={false}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};
